import {
    CustomSimpleErrorToast,
    CustomToast,
    CustomToastParams
} from '@/components/compositions/custom-toast';
import {toast} from 'sonner';

export function showToast(params: CustomToastParams) {
  toast.custom((t) => <CustomToast params={{...params, toastId: t}} className={''} />, {
    duration: params.duration ? params.duration : 5000,
    dismissible: true,
  });
}

export function showSimpleErrorToast(params: CustomToastParams){
  toast.custom((t) => 
      <CustomSimpleErrorToast
          params={{...params, toastId: t}} 
          className={''}
      />, 
      {
        duration: params.duration ? params.duration : 5000,
        dismissible: true
      }
  );
}